import type { Features } from 'models/features';
import * as fixture from 'models/fixture';
import type { FrontRights } from 'models/libs/FrontRights';
import type { StaticProductView } from 'state/product-description/types';

interface ISpUser {
  login: string;
  isInternal: boolean;
  isTrader?: boolean;
  companyName: string;
  bdrId: string;
  environmentDetails: EnvironmentDetails;
  entitlements: FrontRights;
  features: Features;
  impersonator?: Impersonation;
}

interface ContactPhone {
  label: string;
  value: string;
}

interface Impersonation {
  login: string;
}

export interface EnvironmentDetails {
  piwikAnalytics?: {
    piwikBaseUrl?: string;
    piwikSiteId?: number;
  };
  lifecyclePortalUrl: string;
  discoveryUrl: string;
  insightPortalUrl: string;
  thematicInsightsUrl: string;
  macroMattersUrl: string;
  splabUrl: string;
  splabPricingUrl: string;
  appFeedbackUrl: string;
  sparkUrl: string;
  contacts: {
    mail: string;
    phones: ContactPhone[];
  };
}
export function mockSpUser(): ISpUser {
  return {
    features: <Features>{},
    entitlements: fixture.someEntitlements(),
    login: '',
    isInternal: false,
    companyName: '',
    bdrId: '',
    environmentDetails: {
      appFeedbackUrl: '',
      contacts: { mail: '', phones: [] },
      discoveryUrl: '',
      insightPortalUrl: '',
      lifecyclePortalUrl: '',
      macroMattersUrl: '',
      sparkUrl: '',
      splabPricingUrl: '',
      splabUrl: '',
      thematicInsightsUrl: '',
    },
  };
}
interface Company {
  name: string;
  legalLevel: string;
}
export interface MailingList {
  name: string;
  emails: readonly string[];
  id: string;
  fullName: string;
  company: Company;
}

interface SalesDesk {
  id: number;
  longName: string;
}

export interface IUserCurrent extends ISpUser {
  language: string;
  isDarkMode: boolean;

  defaultStaticProductView?: StaticProductView;
  permissions?: readonly Permission[];

  icId: string;

  mailingLists?: readonly MailingList[];
  salesDesks: readonly SalesDesk[];
}

export type UserState = Readonly<IUserCurrent>;

export const initialUserState = {} as UserState;
